<template>
  <div class="container">
    <van-row class="type-wrap">
      <van-col span="12" @click="firstTap">
        <span>{{ firstText ? firstText : '请选择' }}</span>
        <van-icon name="play" />
      </van-col>
      <van-col span="12" @click="secondTap">
        <span>{{ secondText ? secondText : '请选择' }}</span>
        <van-icon name="play" />
      </van-col>
    </van-row>
    <div class="canves">
      <div class="canves-wrap">
        <div class="canves-top">
          <div class="canves-title">全国{{secondText=='全部'?firstText:secondText}}价位走势</div>
          <div class="canves-select" @click="timeTap">
            <span>{{ timeText ? timeText : '请选择' }}</span>
            <van-icon name="play" />
          </div>
        </div>
        <div id="charts"></div>
      </div>
    </div>
    <div class="table-wrap">
      <div class="table">
        <table>
          <tr>
            <th>时间</th>
            <th>价格（元/吨）</th>
            <th>环比变化（元/吨）</th>
            <th>环比（%）</th>
          </tr>
          <tr v-for="(item, i) in tables" :key="i">
            <td>{{item.timeStr}}</td>
            <td>{{item.value}}</td>
            <td>{{item.tongbiValue}}</td>
            <td>{{(item.tongbi*100).toFixed(2)+'%'}}</td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 第一类型选择弹窗 -->
    <van-popup v-model="firstPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="firstColumns"
        @cancel="firstPicker = false"
        @confirm="firstConfirm"
      />
    </van-popup>
    <!-- 第二类型选择弹窗 -->
    <van-popup v-model="secondPicker" round position="bottom">
      <!-- <van-picker
        show-toolbar
        :columns="secondColumns"
        @cancel="secondPicker = false"
        @confirm="secondConfirm"
      /> -->
      <van-picker
        show-toolbar
        value-key="name"
        :columns="secondArr"
        @cancel="secondPicker = false"
        @confirm="secondConfirm"
      />
    </van-popup>
     <!-- 时间选择弹窗 -->
    <van-popup v-model="timePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="timeColumns"
        @cancel="timePicker = false"
        @confirm="timeConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { yearFromCurYear } from '@utils/time.js'
import { category, industryData } from '@api/servicebus/servicebus'
import { Toast } from 'vant'
var myChart
export default {
  data() {
    return {
      firstText: '',
      secondText: '',
      firstPicker: false,
      secondPicker: false,
      columns: [],
      firstColumns: [],
      secondArr: [],
      secondColumns: [],
      cid: '', // 产业Id
      subcid: '', // 栏目Id
      timeText: '',
      timePicker: false,
      timeColumns: [],
      options: {  // echarts数据
        grid: {
          top: '10%',
          left: '15%',
          bottom: '20%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            areaStyle: {}
          }
        ]
      },
      tables: []
    }
  },
  mounted() {
    //   // 时间筛选
    let arr = []
    yearFromCurYear(2010).forEach(item => {
      arr.push(item.value)
    })
    this.timeColumns = arr.reverse()
    this.timeText = this.timeColumns[0]

    myChart = echarts.init(document.getElementById('charts'))

    this.getType()
  },
  methods: {
    getType() {
      category({ type: 3 }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.columns = data
          data.forEach(item => {
            this.firstColumns.push(item.name)
          })

          // 大类
          this.firstText = this.firstColumns[0]
          this.cid = this.columns[0].id

          // 小类
          this.secondArr = this.columns[0].children
          if (this.secondArr.length > 0) {
            this.secondText = this.secondArr[0].children[0].name
            this.subcid = this.secondArr[0].children[0].id
          }

          // 获取列表数据
          this.getList()
        } else {
          Toast(msg)
        }
      })
    },
    getList(num) {
      industryData({ commdityId: this.subcid || this.cid, year: this.timeText }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.tables = data
          // 绘制图表
          let arr = []
          let arr1 = []
          data.forEach(item => {
            arr.push(item.timeStr)
            arr1.push(item.value)
          })
          this.options.xAxis.data = arr
          this.options.series[0].data = arr1
          myChart.setOption(this.options)
        } else {
          Toast(msg)
        }
      })
    //   this.loading = false
    },
    firstTap() {
      this.firstPicker = true
    },
    secondTap() {
      this.secondPicker = true
    },
    firstConfirm(e) {
      this.firstText = e
      // 二级选项联动
      this.columns.forEach(item => {
        if (item.name == e) {
          this.cid = item.id

          // 小类
          this.secondArr = item.children
          if (this.secondArr.length > 0) {
            this.secondText = this.secondArr[0].children[0].name
            this.subcid = this.secondArr[0].children[0].id
          } else {
            this.secondText = '全部'
            this.subcid = ''
          }
        }
      })
      this.getList()
      this.firstPicker = false
    },
    secondConfirm(e) {
      this.secondText = e[1]
      this.secondArr.forEach(item => {
        item.children.forEach(val => {
          if (val.name == e[1]) {
            this.subcid = val.id
          }
        })
      })
      this.getList(1)
      this.secondPicker = false
    },
    timeTap() {
      this.timePicker = true
    },
    timeConfirm(e) {
      this.timeText = e
      this.getList()
      this.timePicker = false
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  width:100%;
  min-height:100vh;
  background:#f7f7f7;
}
.type-wrap {
  width: 100%;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #eee;
  z-index: 10;
  .van-col {
    text-align: center;
    line-height: 36px;
    span {
      font-size: 15px;
    }
    .van-icon {
      font-size: 14px;
      color: #ccc;
      transform: rotate(90deg);
      margin-left: 4px;
    }
  }
}
.canves{
  padding:15px;
  .canves-wrap{
    background:#fff;
    border-radius:10px;
  }
  .canves-top{
    display:flex;
    align-items: center;
    justify-content: space-between;
    padding:10px 15px;
    .canves-title{
      font-size:14px;
      color:#333;
    }
    .canves-select{
      height:26px;
      line-height:20px;
      border:1px solid #999;
      border-radius:50px;
      padding:0 10px;
      span{
        font-size:14px;
        vertical-align: middle;
      }
      .van-icon {
        font-size: 14px;
        color: #333;
        transform: rotate(90deg);
        vertical-align: middle;
        margin-left:6px;
      }
    }
  }
  #charts{
    width:100%;
    height:200px;

  }
}
.table-wrap{
  padding:0 15px 15px;
  .table{
    background:#fff;
    border-radius:10px;
    padding:20px 15px;
    overflow-x: auto;
    table{
      border-collapse: collapse;
      tr{
        height:30px;
      }
      th{
        padding:0 10px;
        white-space:nowrap;
        font-size:14px;
        background:#F2F2F2;
        text-align:center;
      }
      td{
        padding:0 10px;
        white-space:nowrap;
        font-size:14px;
        text-align:center;
      }
    }
    table tr th, table tr td { border:1px solid #ddd; }
  }
}
</style>

